
import { format } from "date-fns";
import { fr, enUS } from "date-fns/locale";
import { useTranslation } from "react-i18next";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { useCurrency } from "@/contexts/CurrencyContext";

interface BillingHistoryProps {
  billingHistory: any[];
  featured?: boolean;
}

export function BillingHistory({ billingHistory, featured = false }: BillingHistoryProps) {
  const { t, i18n } = useTranslation(["athlete", "subscriptions"]);
  const { formatCurrency } = useCurrency();
  const dateLocale = i18n.language === 'fr' ? fr : enUS;

  if (!billingHistory.length) return null;

  return (
    <Card className={featured ? "athlete-subscription-history border-border/70 bg-card/90 shadow-lg" : "bg-card/60 backdrop-blur-xl border border-border/40 shadow-lg"}>
      <CardHeader>
        <CardTitle>{t("subscriptions.billingHistory")}</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="relative overflow-x-auto rounded-xl">
          <table className="w-full text-sm text-left">
            <thead className="text-xs uppercase bg-muted/30 backdrop-blur-sm">
              <tr>
                <th scope="col" className="px-6 py-3">{t("history.date")}</th>
                <th scope="col" className="px-6 py-3">{t("amount", { ns: "common" })}</th>
                <th scope="col" className="px-6 py-3">{t("status", { ns: "common" })}</th>
              </tr>
            </thead>
            <tbody>
              {billingHistory.map((payment) => (
                <tr key={payment.id} className="border-b border-border/30 bg-transparent">
                  <td className="px-6 py-4">
                    {format(new Date(payment.payment_date), "PPP", { locale: dateLocale })}
                  </td>
                  <td className="px-6 py-4">{formatCurrency(payment.amount)}</td>
                  <td className="px-6 py-4">
                    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                      payment.status === 'completed' ? 'bg-green-500/15 text-green-700 dark:text-green-400' : 'bg-amber-500/15 text-amber-700 dark:text-amber-400'
                    }`}>
                      {t(payment.status, { ns: "common" })}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </CardContent>
    </Card>
  );
}
